const MedicalCertificatePage = () => {
  return <div>Medical Certificate</div>;
};

export default MedicalCertificatePage;
